export default __webpack_public_path__ + "images/watermark-logo-footer-white@2x.149b7778f2f1bf46ef7faec7d39f26b6.png";